import { render } from "./SolutionDetailIAM.vue?vue&type=template&id=1da9b396"
import script from "./SolutionDetailIAM.vue?vue&type=script&lang=js"
export * from "./SolutionDetailIAM.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__